import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { IconPin, IconClock, IconInstagram, IconLink } from './ui/Icons';
export function Contact() {
  return <section id="contacto" className="py-24 bg-white" data-id="element-67">
      <div className="container mx-auto px-6 md:px-12" data-id="element-68">
        <div className="flex flex-col lg:flex-row gap-16" data-id="element-69">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-1/3" data-id="element-70">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-mocha mb-8" data-id="element-71">
              Visitanos
            </h2>

            <div className="space-y-8" data-id="element-72">
              <div className="flex items-start gap-4" data-id="element-73">
                <div className="w-10 h-10 rounded-full bg-brand-cream flex items-center justify-center text-brand-mocha shrink-0" data-id="element-74">
                  <IconPin className="w-5 h-5" data-id="element-75" />
                </div>
                <div data-id="element-76">
                  <h4 className="font-medium text-brand-mocha mb-1" data-id="element-77">
                    Ubicación
                  </h4>
                  <p className="text-sm text-brand-mocha/70" data-id="element-78">
                    Erevan 1770
                    <br data-id="element-79" />
                    Malvín, Montevideo
                    <br data-id="element-80" />
                    Uruguay
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-81">
                <div className="w-10 h-10 rounded-full bg-brand-cream flex items-center justify-center text-brand-mocha shrink-0" data-id="element-82">
                  <IconClock className="w-5 h-5" data-id="element-83" />
                </div>
                <div data-id="element-84">
                  <h4 className="font-medium text-brand-mocha mb-1" data-id="element-85">
                    Horarios
                  </h4>
                  <p className="text-sm text-brand-mocha/70" data-id="element-86">
                    Lunes a Viernes: 10:00 - 19:00
                    <br data-id="element-87" />
                    Sábados: 10:00 - 15:00
                    <br data-id="element-88" />
                    Domingos: Cerrado
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-89">
                <div className="w-10 h-10 rounded-full bg-brand-cream flex items-center justify-center text-brand-mocha shrink-0" data-id="element-90">
                  <IconInstagram className="w-5 h-5" data-id="element-91" />
                </div>
                <div data-id="element-92">
                  <h4 className="font-medium text-brand-mocha mb-1" data-id="element-93">
                    Instagram
                  </h4>
                  <a href="https://instagram.com/cfstudio.uy" target="_blank" rel="noopener noreferrer" className="text-sm text-brand-rose hover:text-brand-mocha transition-colors" data-id="element-94">
                    @cfstudio.uy
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-95">
                <div className="w-10 h-10 rounded-full bg-brand-cream flex items-center justify-center text-brand-mocha shrink-0" data-id="element-96">
                  <IconLink className="w-5 h-5" data-id="element-97" />
                </div>
                <div data-id="element-98">
                  <h4 className="font-medium text-brand-mocha mb-1" data-id="element-99">
                    Reservas
                  </h4>
                  <a href="https://cfstudio.koob.uy" target="_blank" rel="noopener noreferrer" className="text-sm text-brand-rose hover:text-brand-mocha transition-colors" data-id="element-100">
                    cfstudio.koob.uy
                  </a>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Map */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full lg:w-2/3 h-[400px] lg:h-auto rounded-2xl overflow-hidden shadow-soft border border-brand-mocha/5" data-id="element-101">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3271.956740698381!2d-56.1070686!3d-34.894987!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x959f80b18b4ddb59%3A0x8e878e1c667b9d99!2sErevan%201770%2C%2011400%20Montevideo%2C%20Departamento%20de%20Montevideo%2C%20Uruguay!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0
          }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación de CF Studio" data-id="element-102" />
          </motion.div>
        </div>
      </div>
    </section>;
}